/**
 * 발주 화면 (/m/bal) 진입 — 화면 모듈 본체는 F/Baljoo/Baljoo.js (페이지 동적 로더가 이 경로를 import 한다).
 *
 * 여기서는 blade #page-data 를 **공유 전역**으로 펼친다. F/Baljoo/*(Render·Submit·Modal·Sosok)와 Ui/BS 가
 * ORDER·editMode 같은 맨이름으로 읽어 왔기 때문이다(옛 blade 인라인 const).
 *
 * ⚠ 모듈 최상위에 두지 않는다 — m.js 는 Pages/Mobile/** 를 head 에서 즉시 평가하므로 최상위 코드는
 * **모든 모바일 화면에서** 돈다. 이 화면의 인스턴스를 만들 때(생성자, initialize 전) 세운다.
 */
import Baljoo from '../../F/Baljoo/Baljoo';

function setupGlobals() {
    const D = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
    Object.assign(window, {
        bonsaList: D.bonsaList,
        gisaList: D.gisaList,
        centerList: D.centerList,
        ORDER: D.order,
        editMode: D.editMode,
        aiQuickFixed: D.aiQuickFixed,
        sosoks: D.sosoks,
        isLimited: D.isLimited,
        isMercury: D.isMercury,
        G5_WORKTIME: D.worktime,   // 시간대별 선택가능한 소요시간버튼 (HowLong 모달에서 사용)
    });
    window.callbackAddress = callbackAddress;
}

/**
 * 주소선택후에 콜백함수 — 지도 검색 창(applyzip_first)이 부르는 창 사이 약속이라 window 에 둔다(setupGlobals).
 * @param arr ( lat : 위도 ( 37.56 ), long : 경도 ( 126.97 ), addr : 주소, place : 장소 이름 )
 */
function callbackAddress(arr) {
    const data = {
        'contract_address': arr['addr'],
        'mem_basepoint': `${arr['lat']},${arr['long']}`,
        'place_name': arr['place'],
        'address_type': arr['address_type'],
    };
    // AI 발주 도우미에서 연 지도면 결과를 그쪽으로 돌려준다.
    // 챗봇은 아직 발주 폼으로 넘어가기 전이라 ORDER 를 직접 건드리면 안 된다.
    if ($j.F.Baljoo.ModalAiChat.acceptMapAddress(data)) return;

    $j.p.onModalApply('map', data);
    // 입력할게 없다면 바텀시트를 닫자.
    if ($j.p.isAllFilled()) {
        $j.Ui.BS.close();
    }
}

export default class BaljooPage extends Baljoo {
    constructor() {
        setupGlobals();   // this 를 쓰지 않으므로 super() 앞에 둘 수 있다 — F/Baljoo 생성자보다 먼저 전역이 선다
        super();
    }
}
